import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import emailjs from '@emailjs/browser';
import './Newsletter.css';

interface Membre {
  mail: string;
}

function Newsletter() {
  const [sujet, setSujet] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState('');

  // Initialisation d'EmailJS
  useEffect(() => {
    emailjs.init({
      publicKey: "nUDhbIVhpDxykfPXl"
    });
  }, []);

  // Fonction pour créer un délai
  const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    setProgress('');

    try {
      // Récupérer les membres avec statut "Valide"
      const membresRef = collection(db, 'Membres');
      const q = query(membresRef, where('statut', '==', 'Valide'));
      const querySnapshot = await getDocs(q);

      // Récupérer les emails des membres
      const emails: Membre[] = querySnapshot.docs.map(doc => ({
        mail: doc.data().mail
      }));

      // Envoi des emails avec délai
      for (let i = 0; i < emails.length; i++) {
        const membre = emails[i];
        
        try {
          await emailjs.send(
            "service_n3i28dc",
            "template_jktxibn",
            {
              to_email: membre.mail,
              subject: sujet,
              message: message
            }
          );

          // Mettre à jour la progression
          setProgress(`Envoi en cours : ${i + 1}/${emails.length}`);

          // Délai de 2 secondes sauf pour le dernier email
          if (i < emails.length - 1) {
            await delay(2000);
          }
        } catch (emailError) {
          console.error(`Erreur d'envoi à ${membre.mail}:`, emailError);
        }
      }

      setSuccess(`Newsletter envoyée à ${emails.length} membres`);
      
      // Réinitialiser les champs
      setSujet('');
      setMessage('');
    } catch (err) {
      console.error('Erreur:', err);
      setError('Une erreur est survenue lors de l\'envoi de la newsletter');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="newsletter-container">
      <h1>Envoyer une Newsletter</h1>
      
      <form onSubmit={handleSubmit} className="newsletter-form">
        <div className="form-group">
          <label htmlFor="sujet">Sujet</label>
          <input
            type="text"
            id="sujet"
            value={sujet}
            onChange={(e) => setSujet(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            rows={6}
          />
        </div>

        {error && <div className="error-message">{error}</div>}
        {progress && <div className="progress-message">{progress}</div>}
        {success && <div className="success-message">{success}</div>}

        <button 
          type="submit" 
          className="submit-btn"
          disabled={loading}
        >
          {loading ? 'Envoi en cours...' : 'Envoyer la Newsletter'}
        </button>
      </form>
    </div>
  );
}

export default Newsletter;